import { Grid } from '@mui/material';
import { memo } from 'react';
import { AccordionEditDataControl as AccordionEditControlDataVM } from 'shell/view-models/edit-data-control';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import { FormikErrors, FormikTouched } from 'formik';

interface FormEditControlDataProps {
  values?: AccordionEditControlDataVM;
  onChange: (
    key: keyof AccordionEditControlDataVM,
    value: AccordionEditControlDataVM[keyof AccordionEditControlDataVM]
  ) => void;
  errors?: FormikErrors<AccordionEditControlDataVM>;
  touched?: FormikTouched<AccordionEditControlDataVM>;
  disabled?: boolean;
}

const FormEditControlDataComponent = ({
  values,
  onChange,
  touched,
  errors,
  disabled,
}: FormEditControlDataProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data decorrenza *"
          value={values?.dateValidity || null}
          onChange={(dataValue) => {
            onChange('dateValidity', dataValue || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateValidity"
              fullWidth
              error={touched?.dateValidity && Boolean(errors?.dateValidity)}
              helperText={errors?.dateValidity}
              disabled={disabled}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

FormEditControlDataComponent.displayName = 'Form Edit Control data component';

const FormEditControlData = memo(FormEditControlDataComponent);

export default FormEditControlData;
